import { useTranslation } from "react-i18next";
import { books } from "../data/books";
import BookCard from "./BookCard";
import blogPosts from "@/data/blogPosts";

const Publications = () => {
  const { t, i18n } = useTranslation();
  const blogLanguage = i18n.resolvedLanguage?.startsWith("en") ? "en" : "da";
  const blogDateFormatter = new Intl.DateTimeFormat(blogLanguage === "en" ? "en-US" : "da-DK", {
    day: "numeric",
    month: "short",
    year: "numeric"
  });
  const allBlogPosts = [...blogPosts].sort((a, b) => b.publishedAt.localeCompare(a.publishedAt));
  const getParagraphs = (text: string) =>
    text
      .split(/\n\s*\n/g)
      .map((paragraph) => paragraph.trim())
      .filter(Boolean);

  return (
    <section id="publications" className="py-12 sm:py-16 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#006B5F] mb-4">
            {t('publications.title')}
          </h2>
          <p className="text-lg text-gray-700 italic max-w-2xl mx-auto">
            {t('publications.subtitle')}
          </p>
        </div>

        {/* Blog Section */}
        <div className="mb-16">
          <div className="text-center mb-8">
            <h3 className="text-2xl sm:text-3xl font-bold text-[#006B5F] mb-3">
              {t('publications.blog.latestTitle')}
            </h3>
            <p className="text-lg text-gray-600 max-w-xl mx-auto">
              {t('publications.blog.subtitle')}
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {allBlogPosts.map((post) => (
                <article id={post.id} key={post.id} className="scroll-mt-24 rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
                  <p className="text-xs text-gray-500">
                    {blogDateFormatter.format(new Date(post.publishedAt))}
                  </p>
                  <h4 className="mt-1 text-lg font-semibold text-[#006B5F]">
                    {post.title[blogLanguage]}
                  </h4>
                  <p className="mt-2 text-gray-700 leading-relaxed">
                    {post.excerpt[blogLanguage]}
                  </p>
                  <details className="mt-3">
                    <summary className="cursor-pointer text-sm font-medium text-[#006B5F] hover:text-[#005A4F]">
                      {t('publications.blog.readMore')}
                    </summary>
                    <div className="mt-3 space-y-3">
                      {getParagraphs(post.content[blogLanguage]).map((paragraph, index) => (
                        <p key={`${post.id}-paragraph-${index}`} className="text-gray-700 leading-relaxed">
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </details>
                </article>
              ))}
            </div>
          </div>
        </div>

        {/* Books Section */}
        <div className="mb-16">
          <div className="text-center mb-8">
            <h3 className="text-2xl sm:text-3xl font-bold text-[#006B5F] mb-3">
              {t('publications.books.title')}
            </h3>
            <p className="text-lg text-gray-600 max-w-xl mx-auto">
              {t('publications.books.subtitle')}
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="space-y-8">
              {books.map((book) => (
                <BookCard key={book.id} book={book} />
              ))}
            </div>
          </div>
        </div>


      </div>
    </section>
  );
};

export default Publications;
